<on-page-title
    [title]="'company.create-crompany.title' | translate"
></on-page-title>

<div
    [innerHTML]="
        'company.create-crompany.text' | translate: { appName: appName }
    "
></div>
